<template>
    <div id="admin-wines">
        <div v-for="wine in wines" :key="wine.id" class="admin-wines-row">
            <div class="admin-wines-img">
                <img :src="wine.image | optimizeWine" class="wines-img-preview" alt="">
            </div>
            <div class="admin-wines-col">
                <div class="row-header">Name</div>
                <div class="admin-blog-post-title">
                    {{ wine.name }}
                </div>
            </div>
            <div class="admin-wines-col">
                <div class="row-header">Producer</div>
                <div class="admin-blog-post-datecreated">
                    {{ wine.producer }}
                </div>
            </div>
            <div class="admin-wines-col">
                <div class="row-header">Rating</div>
                <div class="admin-blog-post-datepublished">
                    {{ wine.rating }}
                </div>
            </div>
            <div class="admin-wines-col">
                <div class="row-header">Public</div>
                <div class="admin-blog-post-datepublished">
                    {{ wine.visibility }}
                </div>
            </div>
            <div class="admin-wines-button" v-on:click="$emit('wine', 'EditWine', wine)">
                Edit
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['wines'])
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_100/')
            return newUrl
        }
    }
}
</script>

<style>
.admin-wines-row {
    display: flex;
    justify-content: space-between;
    height:100px;
    width:90%;
    padding:5px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: white;

}
.admin-wines-img {
    height:100px;
    width: 100px;
    overflow: hidden;
}
.admin-wines-col {
    flex-basis: 20%;
}
.wines-img-preview {
    max-height:100px;
    width:auto;
    margin: 0 auto;
}
.admin-wines-title {
    font-size: 26px;
    max-height: 40px;
    overflow: hidden;
}
.admin-blog-post-datecreated {
    font-size: 26px;
}
.admin-blog-post-datepublished {
    font-size: 26px;
}
.admin-blog-post-visibility {
    font-size: 26px;
}
.admin-wines-button {
    margin-top: 25px;
    height: 50px;
    width: 100px;
    background-color: rgb(69, 144, 194);
    line-height: 50px;
    color: white;
    border-radius: 5px;
    margin-right: 5px;
    cursor: pointer;
}
.row-header {
    line-height: 30px;
    opacity: 0.5;
}
</style>